import { inovePagarme } from '../../../../../services/pagarmeApi'
import { useAuth } from '../../../../../context/AuthContext'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { useState, useCallback, useEffect } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs'
import { useHistory } from 'react-router'
import { UserCard } from '../../../userCard'
import { toast } from 'react-toastify'


import { Container } from './style'


export function OnlinePayment({
    handleAddPaymentMethod,
    setPaymentMethodsModalOpened,
    handleSetChangeValue
}) {
    const [loadingCards, setLoadingCards] = useState(true)
    const [cards, setCards] = useState([])
    const { signOut } = useAuth()

    const history = useHistory()

    const getCards = useCallback(async () => {
        try {
            await inovePagarme.get(`/getCards/${localStorage.getItem('@Inoveclube:token')}`)
                .then(response => (
                    
                    setCards(response.data)
                ))
            setLoadingCards(false)
        } catch (error) {           
            if (error.response.status === 401 || error.response.status === 500) {
                signOut()
                history.push('/login');
                toast.warning('Sua sessão foi expirada')
            } else {
                toast.error(error.response.data.message)
                history.push('/profile')
            }
        }
    }, [history, signOut])


    function handleSelectCard(data) {
        //console.log(data)
        let object = {
            idPayment: 1000,
            icon: data.brand.toLowerCase(),
            description: `${data.brand} ••••${data.last_digits}`,
            idCard: data.id,
            type: 'online'
        }
        localStorage.setItem('@Inoveclube:onlinepmtd', JSON.stringify(object))

        handleSetChangeValue(0)
        handleAddPaymentMethod(object)
        setPaymentMethodsModalOpened(false)
    }

    useEffect(() => {
      getCards()
    }, [getCards])



    if (loadingCards)
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />


    return (
        <Container>
            {
                cards.map(card => (
                    <UserCard
                        key={card.id}
                        deleteCardVisible={false}
                        cardDatas={card}
                        cards={cards}
                        setCards={setCards}
                        onClick={() => handleSelectCard(card)}
                    />
                ))
            }

            <div className="logButton">
                <BsPlusCircleFill onClick={() => history.push('/cardregister')} />
            </div>

        </Container>
    )
}
